import script from "./ValidationIndicator.vue?vue&type=script&lang=ts&setup=true"
export * from "./ValidationIndicator.vue?vue&type=script&lang=ts&setup=true"

import "./ValidationIndicator.vue?vue&type=style&index=0&id=03816fc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03816fc6"]])

export default __exports__